import { Box, Divider, Stack, Text } from '@mantine/core';

import { ControlResult } from '@e-origin/shared';

import classes from './ControlResultDetails.module.css';

interface ControlResultProps {
  controlResult: ControlResult[];
}

export const ControlResultDetails: React.FC<ControlResultProps> = ({ controlResult }) => {
  if (!controlResult?.length) {
    return;
  }

  return (
    <>
      <Divider mb="md" />
      {controlResult.map((item, index) => (
        <Stack key={`control-result-${index}`} pt={10} pb={20}>
          <Text className={classes.sectionTitle}>Control result</Text>
          <Box className={classes.row}>
            <div>
              <label>Date</label>
              <p>{item.date ?? 'N/A'}</p>
            </div>
            <div>
              <label>Control code</label>
              <p>{item.code ?? 'N/A'}</p>
            </div>
          </Box>
          <Box className={classes.row}>
            <div>
              <label>Remarks</label>
              <p>{item.remarks}</p>
            </div>
          </Box>
          {(item.resultsOfControl || []).map((result, resultIndex) => (
            <Stack mt={15} ml={20} key={`result-of-control-${index}-${resultIndex}`}>
              <Text className={classes.subSectionTitle}>Result of control</Text>
              <Box className={classes.row}>
                {result.goodsItemNumber && (
                  <Box className={classes.row}>
                    <div>
                      <label>Item number</label>
                      <p>{result.goodsItemNumber}</p>
                    </div>
                  </Box>
                )}
                <div>
                  <label>Risk area code</label>
                  <p>{result.riskAreaCode ?? 'N/A'}</p>
                </div>
                <div>
                  <label>Control type</label>
                  <p>{result.controlType}</p>
                </div>
                <div>
                  <label>Control date</label>
                  <p>{result.controlDate ?? 'N/A'}</p>
                </div>
                <div>
                  <label>Remarks</label>
                  <p>{result.remarks}</p>
                </div>
              </Box>
              {(result.controlDetails || []).map((controlDetail, controlDetailIndex) => (
                <Stack mt={15} ml={20} key={`control-result-detail-${index}-${resultIndex}-${controlDetailIndex}`}>
                  <Text className={classes.subSectionTitle}>Control Detail</Text>
                  <Box className={classes.row}>
                    <div>
                      <label>Type of discrepancies</label>
                      <p>{controlDetail.typeOfDiscrepancies}</p>
                    </div>
                    <div>
                      <label>Attribute pointer</label>
                      <p>{controlDetail.attributePointer}</p>
                    </div>
                    <div>
                      <label>Corrected value</label>
                      <p>{controlDetail.correctedValue}</p>
                    </div>
                    <div>
                      <label>Remarks</label>
                      <p>{controlDetail.remarks}</p>
                    </div>
                  </Box>
                </Stack>
              ))}
            </Stack>
          ))}
        </Stack>
      ))}
    </>
  );
};
